import { Pendencia, PendenciaMensagem } from '@/types/_'
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class PendenciaSolicitacao extends CoreBase implements IPendenciaSolicitacao {
  async uploadDocumento(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoPendenciaApi.uploadDocumento(params.formData, params.hospitalId, params.tipoDocumento)
    return response
  }

  async sendEnviarMensagem(solicitacaoId: string, pendencia: Pendencia): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.enviarMensagemPendencia(solicitacaoId, pendencia)
    return response
  }

  async getMensagemAberta(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.getMensagemAberta(solicitacaoId)
    return response
  }

  async abrirMensagem(solicitacaoId: string, pendenciaMensagem: PendenciaMensagem[]): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.abrirMensagem(solicitacaoId, pendenciaMensagem)
    return response
  }

  async encerrarPendencia(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.encerrarPendencia(solicitacaoId)
    return response
  }

  async abrirPendenciaAdministrativa(solicitacaoId: string, data: { comentarios: string [] }): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.abrirPendenciaAdministrativa(solicitacaoId, data)
    return response
  }

  async resolverPendenciaAdministrativa(solicitacaoId: string, data: { comentarios: string [] }): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.resolverPendenciaAdministrativa(solicitacaoId, data)
    return response
  }

  async medicoResponde(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoPendenciaApi.medicoResponde(solicitacaoId)
    return response
  }
}

interface IPendenciaSolicitacao extends ICoreBase {
  uploadDocumento(params: any): Promise<ResponseApi>
  sendEnviarMensagem(solicitacaoId: string, pendencia: Pendencia): Promise<ResponseApi>
  getMensagemAberta(solicitacaoId: string): Promise<ResponseApi>
  abrirMensagem(solicitacaoId: string, pendenciaMensagem: PendenciaMensagem[]): Promise<ResponseApi>
  encerrarPendencia(solicitacaoId: string): Promise<ResponseApi>
  medicoResponde(solicitacaoId: string): Promise<ResponseApi>

  abrirPendenciaAdministrativa(solicitacaoId: string, data: { comentarios: string [] }): Promise<ResponseApi>
  resolverPendenciaAdministrativa(solicitacaoId: string, data: { comentarios: string [] }): Promise<ResponseApi>
}

export {
  PendenciaSolicitacao,
  IPendenciaSolicitacao,
}
